// extracted by mini-css-extract-plugin
export var ripple = "ripple-module--ripple--2-zs1";